import { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "@/components/ui/table";
import { Link } from "react-router-dom";
import { inr, ymd } from "@/lib/format";
import { AlertTriangle } from "lucide-react";

export default function Overdue() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/overdue").then(({ data }) => setData(data));
  }, []);

  const Section = ({ title, items, kindLabel, color }) => (
    <Card className="border-slate-200 overflow-hidden">
      <div className={`px-5 py-4 border-b border-slate-200 flex items-center justify-between ${color}`}>
        <div className="flex items-center gap-2">
          <AlertTriangle className="w-4 h-4" />
          <h3 className="font-display font-bold">{title}</h3>
        </div>
        <div className="text-sm">
          Total: <span className="font-semibold">{inr(items.reduce((s, x) => s + x.outstanding, 0))}</span>
        </div>
      </div>
      <Table className="data-table">
        <TableHeader>
          <TableRow>
            <TableHead>{kindLabel}</TableHead>
            <TableHead>Party</TableHead>
            <TableHead>Due Date</TableHead>
            <TableHead className="text-right">Days Overdue</TableHead>
            <TableHead className="text-right">Outstanding</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {items.length === 0 && (
            <TableRow><TableCell colSpan={5} className="text-center py-8 text-slate-500">Nothing overdue. 🎉</TableCell></TableRow>
          )}
          {items.map((d) => (
            <TableRow key={d.doc_id}>
              <TableCell><Link to={`/documents/${d.doc_id}`} className="font-medium hover:text-indigo-700">{d.number}</Link></TableCell>
              <TableCell>{d.party_name}</TableCell>
              <TableCell className="text-slate-500">{ymd(d.due_date)}</TableCell>
              <TableCell className="text-right">
                <Badge variant="outline" className={d.days_overdue > 30 ? "bg-rose-50 text-rose-700 border-rose-200" : d.days_overdue > 0 ? "bg-amber-50 text-amber-700 border-amber-200" : ""}>
                  {d.days_overdue > 0 ? `${d.days_overdue} days` : "Due today"}
                </Badge>
              </TableCell>
              <TableCell className="text-right number-cell font-semibold">{inr(d.outstanding)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Card>
  );

  return (
    <div>
      <PageHeader title="Overdue" subtitle="Chase receivables and manage payables" />
      <div className="px-8 py-6 space-y-6">
        {!data ? (
          <div className="text-slate-500">Loading…</div>
        ) : (
          <>
            <Section
              title="Overdue Receivables (Customers owe you)"
              items={data.receivable}
              kindLabel="Invoice"
              color="bg-rose-50 text-rose-700"
            />
            <Section
              title="Overdue Payables (You owe suppliers)"
              items={data.payable}
              kindLabel="Purchase Order"
              color="bg-amber-50 text-amber-700"
            />
          </>
        )}
      </div>
    </div>
  );
}
